var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.342,
    height: 53.343,
    viewBox: "0 0 53.342 53.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47698",
    transform: "translate(-6.333 -6.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5361",
    cx: 23.337,
    cy: 23.337,
    r: 23.337,
    transform: "translate(9.667 9.667)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45934",
    d: "M1938.7 1859.443a26 26 0 1 1-26 26 26.034 26.034 0 0 1 26-26m0-.667a26.671 26.671 0 1 0 26.671 26.671 26.7 26.7 0 0 0-26.671-26.671z",
    transform: "translate(-1905.697 -1852.443)",
    style: {
      fill: "#dfdfdf"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "01.facebook",
    transform: "translate(10.526 9.59)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.891 40.825-.311 2.691a.5.5 0 0 1-.495.451h-2.808l-.014 7.978a.36.36 0 0 1-.351.363h-2.846a.351.351 0 0 1-.351-.365v-7.976h-2.106a.5.5 0 0 1-.5-.509l-.009-2.691a.506.506 0 0 1 .5-.513h2.117v-2.6c0-3.016 1.79-4.657 4.416-4.657h2.152a.505.505 0 0 1 .5.513v2.264a.506.506 0 0 1-.5.513h-1.32c-1.427 0-1.7.7-1.7 1.717v2.249H69.4a.505.505 0 0 1 .495.57z",
    transform: "translate(-48.702 -26.359)",
    style: {
      fill: "#151aae"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSocial);
export default __webpack_public_path__ + "static/media/facebook-social.0f4d2a31afe1fa122a5084c3bd7695c2.svg";
export { ForwardRef as ReactComponent };